import { pageSizeEnum } from '@/constants/pageSizeOptionList';
import { routeName } from '@/constants/routeName';
import WorkerNotice from '@/entity/WorkerNotice';
import { FormDataWorkerNotice } from '@/form/form-data/FormDataWorkerNotice';
import { WorkerNoticePost } from '@/service-data/worker-notice/WorkerNoticePost';
import { WorkerNoticePut } from '@/service-data/worker-notice/WorkerNoticePut';
import { workerService } from '@/services';
import { workerNoticeService } from '@/services/worker-notice';
import { defineStore } from 'pinia';
import { computed, ref, } from 'vue';
import { useRoute } from 'vue-router';
/** 초기화 되지 않는 데이터 */
export const prevData = {
    pageSizeType: '',
    pageNumber: 0,
};
// 라이더 공지사항
export const piniaWorkerNotice = defineStore('workerNotice', () => {
    // init
    const route = useRoute();
    // state
    const selectedDateText = ref('');
    /** 상세정보 */
    const itemDetail = ref(new WorkerNotice());
    /** 검색 */
    const filterOption = ref({
        pageNumber: 1,
        searchWord: {
            /** 검색유형 */
            field: '',
            /** 검색어 */
            value: '',
        },
        pageSizeType: pageSizeEnum['50'],
    });
    /** 리스트 */
    const itemList = ref([]);
    /** 허브 리스트. 허브 리스트는 vuex에서 가져온다. */
    // const hubList;
    /** 페이지네이션 */
    const paginationData = ref({});
    /** 수정, 등록 폼데이터 */
    const formData = ref(new FormDataWorkerNotice());
    /** 비교를 위한 원본 데이터 */
    const originFormData = ref(new FormDataWorkerNotice());
    /** 허브의 워커 리스트 */
    const workerList = ref([]);
    // computed
    /** 게시글 수 */
    const noticeTotalCount = computed(() => paginationData.value.total || 0);
    /** 현재 페이지 타입 */
    const isCreatePage = computed(() => route.name === routeName.DISTRIBUTOR_NOTICE_CREATE);
    // method
    /**
     * 리스트 조회
     */
    const getNoticeList = async () => {
        const response = await workerNoticeService.getItemList({
            pageNumber: filterOption.value.pageNumber,
            pageSize: filterOption.value.pageSizeType,
        });
        itemList.value = response.list;
        paginationData.value = response.paginationData;
    };
    /**
     * 단건 조회
     */
    const getNotice = async (id) => {
        const response = await workerNoticeService.getItem(id);
        itemDetail.value = response;
        return response;
    };
    /**
     * 단건 등록
     */
    const createNotice = async () => {
        const serviceData = new WorkerNoticePost(formData.value);
        const response = await workerNoticeService.createItem(serviceData);
        return response;
    };
    /**
     * 단건 수정
     */
    const updateNotice = async () => {
        const serviceData = new WorkerNoticePut(formData.value);
        const response = await workerNoticeService.updateItem(serviceData);
        return response;
    };
    /**
     * 단건 삭제
     */
    const deleteNotice = async (id) => {
        const response = await workerNoticeService.deleteItem(id);
        return response;
    };
    /**
     * 단건 초기화
     */
    const clear = () => {
        itemDetail.value = new WorkerNotice();
        formData.value = new FormDataWorkerNotice();
        originFormData.value = new FormDataWorkerNotice();
    };
    /**
     * 폼 데이터 셋팅
     */
    const setFormData = (_formData) => {
        // res to form
        formData.value = new FormDataWorkerNotice(_formData);
        originFormData.value = new FormDataWorkerNotice(_formData);
    };
    /**
     * 워커 리스트 조회
     */
    const getWorkerList = async () => {
        const param = {
            pageNumber: 1,
            pageSize: 1000,
            hubId: formData.value.selectedHub,
            filters: [],
            sortOption: [],
        };
        // 허브아이디 없으면 호출 x
        if (!param.hubId) {
            return;
        }
        const response = await workerService.getWorkerListOnly(param);
        workerList.value = response.list;
    };
    /** input 출력용 텍스트 업데이트 */
    const updateDateText = () => {
        selectedDateText.value = formData.value.selectedDate.join('~');
    };
    return {
        isCreatePage,
        formData,
        originFormData,
        itemDetail,
        filterOption,
        itemList,
        paginationData,
        getNotice,
        getNoticeList,
        deleteNotice,
        createNotice,
        updateNotice,
        setFormData,
        clear,
        noticeTotalCount,
        getWorkerList,
        updateDateText,
        workerList,
        selectedDateText,
    };
});
